import React from "react";
const VideoIframe = ({ myFundDetails, newsFeedDetails, messageResult }) => {
  const pauseVideo = () => {
    document.getElementById("video")?.pause();
  };

  const onKeyPressEsc = (e) => {
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        document.getElementById("video")?.pause();
      }
    });
  };

  return (
    <>
      {myFundDetails && myFundDetails
        ? myFundDetails.record?.map((v, index) => {
            return (
              <div
                key={index}
                className="modal fade"
                id={`video-pop${index}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                onKeyDown={onKeyPressEsc}
                onClick={pauseVideo}
              >
                <div
                  className="modal-dialog"
                  style={{ minWidth: "70%" }}
                  role="document"
                >
                  <div
                    className="modal-content modal-background"
                    onClick={pauseVideo}
                  >
                    <div className="modal-body">
                      {/* <div className="d-flex justify-content-end">
                        <button
                          id="close"
                          type="button"
                          className="btn-close button-modal-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={pauseVideo}
                        ></button>
                      </div> */}

                      <div className="embed-responsive embed-responsive-16by9 mt-1 d-flex justify-content-center">
                        {v?.type?.toLowerCase() === "video" ||
                        v?.type === null ? (
                          <video
                            id="video"
                            controls
                            className="embed-responsive-item"
                            width="1300px"
                            height="730px"
                          >
                            <source src={v?.url} type="video/mp4" />
                          </video>
                        ) : (
                          <img
                            width="80%"
                            height="80%"
                            src={v?.url}
                            alt=""
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        : newsFeedDetails &&
          newsFeedDetails.map((item, id) => {
            return item?.records.map((v, index) => {
              return (
                <div
                  key={v.id}
                  className="modal fade"
                  id={`video-pop${v.id}`}
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                  onKeyDown={onKeyPressEsc}
                  onClick={pauseVideo}
                >
                  <div
                    className="modal-dialog"
                    style={{ minWidth: "70%" }}
                    role="document"
                  >
                    <div
                      className="modal-content modal-background"
                      onClick={pauseVideo}
                    >
                      <div className="modal-body">
                        {/* <div className="d-flex justify-content-end">
                        <button
                          id="close"
                          type="button"
                          className="btn-close button-modal-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={pauseVideo}
                        ></button>
                      </div> */}

                        <div className="embed-responsive embed-responsive-16by9 mt-1 d-flex justify-content-center">
                          {v?.type?.toLowerCase() === "video" ||
                          v?.type === null ? (
                            <video
                              id="video"
                              controls
                              className="embed-responsive-item"
                              width="1300px"
                              height="730px"
                            >
                              <source src={v?.url} type="video/mp4" />
                            </video>
                          ) : (
                            <img
                              width="80%"
                              height="80%"
                              src={v?.url}
                              alt=""
                            ></img>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            });
          })}
      {messageResult &&
        messageResult.length > 0 &&
        messageResult.map((item, index) => {
          return (
            item?.recordFiles &&
            item?.recordFiles.length > 0 &&
            item?.recordFiles.map((v, id) => {
              return (
                <div
                  key={index + id}
                  className="modal fade"
                  id={`video-pop${index + id}`}
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                  onKeyDown={onKeyPressEsc}
                  onClick={pauseVideo}
                >
                  <div
                    className="modal-dialog"
                    style={{ minWidth: "70%" }}
                    role="document"
                  >
                    <div
                      className="modal-content modal-background"
                      onClick={pauseVideo}
                    >
                      <div className="modal-body">
                        <div className="embed-responsive embed-responsive-16by9 mt-1 d-flex justify-content-center">
                          {v?.recordType?.toLowerCase() === "video" ||
                          v?.recordType === null ? (
                            <video
                              id="video"
                              controls
                              className="embed-responsive-item"
                              width="1300px"
                              height="730px"
                            >
                              <source src={v?.documentUrl} type="video/mp4" />
                            </video>
                          ) : (
                            <img
                              width="80%"
                              height="80%"
                              src={v?.documentUrl}
                              alt=""
                            ></img>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          );
        })}
    </>
  );
};

export default VideoIframe;
